import { DynamicFormProvider, useDynamicFormState } from "./DynamicFormProvider";
import { traverseQuestionCard } from "./shared/TraverseQuestionCard";
import { isYesOrNoValue, yesOrNoInfo, YesOrNoInputSelectedValue } from "./inlineForm/inputs/YesOrNo";
import { StyledInlineTextInput } from "./inlineForm/inputs/Text";
import { MultiStepForm } from "./multiStepForm/MultiStepForm";
import { InlineForm, InlineFormSection } from "./inlineForm/InlineForm";
import { InlineFieldPrimary } from "./inlineForm/InlineField";
import { InlineEntityMultiSelect } from "./shared/InlineEntityMultiSelect";
import { ErrorMessage } from "./inlineForm/ErrorMessage";
import { inlineInputStateStyles, useInlineInputState } from "./inlineForm/inputs/InlineInputState";
import { MultiStepFormDialog } from "./multiStepForm/MultiStepformDialog";
import { formStateToDrawerHeaderStatus } from "./shared/formStateToDrawerHeaderStatus";
import { DynamicInput } from "./DynamicInput";
import { answerToAnswerRequest } from "./types";
import { UnsavedChangesDialog } from "./shared/UnsavedChangesDialog";
export type * from "./types";

export const DynamicForm = {
  /** Components */
  Provider: DynamicFormProvider,
  InlineForm,
  InlineFormSection,
  InlineFieldPrimary,
  InlineEntityMultiSelect,
  Input: DynamicInput,
  Form: MultiStepForm,
  ErrorMessage,
  YesOrNoInputSelectedValue,
  StyledInlineTextInput,
  MultiStepFormDialog,
  UnsavedChangesDialog,

  /** Helpers */
  inlineInputStateStyles,
  answerToAnswerRequest,
  useInlineInputState,
  traverseQuestionCard,
  isYesOrNoValue,
  yesOrNoInfo,
  formStateToDrawerHeaderStatus,
  useFormState: useDynamicFormState,
};
